import { faBookOpen } from '@fortawesome/pro-solid-svg-icons';
import { Callout, Text } from '@scale/scaleui-radix';
import { CompassInstructions } from '@scale/compass-ui/components/CardInstructions';

export const UpdateMetadataInstructions = () => {
  return (
    <CompassInstructions
      header="How to use the Update Metadata card"
      storageKey="updateMetadataInstructionsExpanded"
      disableCollapse={true}
      icon={faBookOpen}
    >
      <Callout.Text>
        <Text as="p">
          <div className="text-sm text-gray-600">
            This card will update metadata for tasks based on the previous table. Here's how it
            works:
            <ul className="list-disc ml-6 mt-2">
              <li>Column headers will be used as the property names.</li>
              <li>A column must exist with the title Task ID.</li>
              <li>Only selected columns will be updated.</li>
              <li>
                If the header matches an existing property, the value will be updated with the
                values in the table.
              </li>
              <li>
                If the header matches an existing property and the value is the sentinel value{' '}
                <code>&lt;remove&gt;</code>, that metadata property will be removed from the task.
              </li>
              <li>
                If the header does not match any existing properties, it will be added as a new
                property.
              </li>
              <li>
                To update the task language code, specify header <code>languageCode</code>. This
                will always update the languageCode field and template variable.
              </li>
              <li>The params of the task will be updated to match the task metadata.</li>
            </ul>
          </div>
        </Text>
      </Callout.Text>
    </CompassInstructions>
  );
};
